// Site type system
import '@fontsource-variable/source-serif-4'
import '@fontsource/ibm-plex-sans-condensed/400.css'
import '@fontsource/ibm-plex-sans-condensed/500.css'
import '@fontsource/ibm-plex-sans-condensed/600.css'

// Your global styles
import './src/normalize.css'
import './src/styles/globals.css'

import rootWrapper from './rootWrapper'
export const wrapPageElement = rootWrapper
